// JWT update interval in minutes
const JwtUpdateInterval =
    1000 * 60 * parseInt(process.env.MIX_JWT_UPDATE_INTERVAL || 1)

const updateJwt = async () => {
    if (Vue.prototype.$user != null) {
        const { data: token } = await axios.get('/api/me/jwt/token')
        Vue.prototype.$jwt = token
    }
}

const plugin = {
    install() {
        Vue.prototype.$jwt = Vue.$cookies.get("jwt_token")
        // Start JWT update loop
        setInterval(updateJwt, JwtUpdateInterval)
    }
}

Vue.use(plugin)



// WEBPACK FOOTER //
// ./resources/assets/js/jwt.js